import { createContext } from 'react';

const GeniatechContext = createContext({});
export default GeniatechContext;
